import { equals2, filterL, go, head, mapL } from "fxjs/es";
export const resetCuttingLineStrokeStyle = (self, { id }) => {
  const cutting_line_display_path_el = go(
    self._els.values(),
    filterL(({ id: id2 }) => equals2(id)(id2)),
    mapL(({ cutting_line_display_path_el: el }) => el),
    head
  );
  if (cutting_line_display_path_el == null) {
    throw new Error(`id 에 해당하는 재단선을 찾을 수 없습니다.`);
  }
  const path_el = cutting_line_display_path_el;
  path_el.setAttributeNS(null, "stroke", "#6D6D6D");
  path_el.setAttributeNS(null, "stroke-width", `1`);
};
